import React, { Component } from "react";
import { Card, InputGroup, Button, Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
//import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import ReactTooltip from 'react-tooltip';
import moment from "moment";

import ModalAlertDialog from "../../modals/ModalAlertDialog.jsx";
import ModalSlideDialog from "../../modals/ModalSlideDialog.jsx";

import GlasschainHttpClient from "providers/http/GlasschainMsaHttpClient";
import AuthService from "providers/auth/AuthService";
import OrgConfiguration from "../../../models/OrgConfiguration.js";
import GridLayout from "../../../models/GridLayout.js";

import { MsaReceiptStatusType } from "models/MsaReceiptStatusType.js";

const GRIDCOLSTATE = "gridcolstate";
const GRIDSORTMODE = "gridsortmode";
const GRIDFILTERMODE = "gridfiltermode";

const refreshDelay = 120000;

export default class ReceiptsGridCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gridData: [],
      isLoading: true,
      showSlides: false,
      slideInfo: { title: "", slides: [{ url: "", caption: "" }] },
      showAlert: false,
      alertTitle: "",
      alertType: "info",
      alertMessage: "",
      selectedRow: null
    };

    this.auth = new AuthService();
    this.httpClient = new GlasschainHttpClient();
    this.gcid = this.auth.getGcid();
    this.syncTimer = null;

    this.refreshGridData = this.refreshGridData.bind(this);
    this.onBtnExportDataAsCsv = this.onBtnExportDataAsCsv.bind(this);
    this.onBtnDownloadDetailedDataAsCsv = this.onBtnDownloadDetailedDataAsCsv.bind(this);

    this.onBtnSaveLayout = this.onBtnSaveLayout.bind(this);
    this.onBtnResetLayout = this.onBtnResetLayout.bind(this);
    this.onBtnRestoreLayout = this.onBtnRestoreLayout.bind(this);

    this.showAlertDialog = this.showAlertDialog.bind(this);
    this.onCloseAlert = this.onCloseAlert.bind(this);


    this.columnDefs = 
    [
         //Cant include nested values because access isnt guaranteed
        {headerName: "Status", field: "status.flowStatus", sortable: true, filter: true, resizable: true, maxWidth: 200, cellStyle: this.lineStatusStyle},
        {headerName: "Date-Time", field: "receiveDateTime", sortable: true, filter: true, resizable: true, maxWidth: 120, cellRenderer: function(params) {return moment(params.value).format("YY-MM-DD HH:mm")}},
        {headerName: "Block Name", field: "lines.0.blockName", sortable: false, filter: true, resizable: true, maxWidth: 250},
        // {headerName: "Grower", field: "lines.0.labelName", sortable: false, filter: true, resizable: true, maxWidth: 120},
         {headerName: "Total Qty", field: "tagUnitQty", sortable: true, filter: true, resizable: true,maxWidth: 90},
         {headerName: "Pallets", field: "tagPalletQty", sortable: true, filter: true, resizable: true,maxWidth: 90},
        // {headerName: "Status", field: "status.flowStatus", sortable: true, filter: true, resizable: true, maxWidth: 150, cellStyle: this.lineStatusStyle},
        // {headerName: "Transaction", field: "transactionId", sortable: false, filter: true, resizable: true, minWidth:300, maxWidth: 300},
        {headerName: "Receipt ID", field: "tagId", sortable: true, filter: true, resizable: true, maxWidth: 120},
        // {headerName: "Total Units", field: "tagUnitQty", sortable: false, filter: false, resizable: true, maxWidth: 120, type: "numericColumn"},
        {headerName: "Comment", field: "lot", sortable: true, filter: true, resizable: true, maxWidth: 200},
        {headerName: "Reference", field: "reference", sortable: true, filter: true, resizable: true, maxWidth: 250},
        {headerName: "Location", field: "warehouseName", sortable: true, filter: true, resizable: true, maxWidth: 250}
  
    ];
 

  }

  

  async componentDidMount() {
    if (!this.auth.loggedIn()){
      this.props.onLoginExpire();
    }
    await this.refreshGridData();
    this.syncTimer = setInterval(() => this.tick(), refreshDelay);
    console.log("Set Receipts Grid syncTimer: " + this.syncTimer);

  }

  componentWillUnmount() {
    if ((this.syncTimer) && (this.syncTimer !==""))
    {
      console.log("clearing Receipts Grid interval on componentWillUnmount...");
      clearInterval(this.syncTimer);
    }
  }


  async componentDidUpdate(prevProps, prevState){
      if (this.props.gridQueryString != prevProps.gridQueryString){
        if ((this.syncTimer) && (this.syncTimer !==""))
        {
          console.log("clearing Receipts Grid interval on componentWillUnmount...");
          clearInterval(this.syncTimer);
        }
        await this.refreshGridData();
        this.syncTimer = setInterval(() => this.tick(), refreshDelay);
      }
  }


  async tick()
  {
    console.log("Receipt Grid Tick...");
    if ((this.syncTimer) && (this.syncTimer !==""))
    {
      console.log("clearing Receipt Grid interval on tick...");
      clearInterval(this.syncTimer);
    }
    await this.refreshGridData();
    this.syncTimer = setInterval(() => this.tick(), refreshDelay);
  }



  async refreshGridData(){
    this.setState({isLoading: true});
    console.log(this.props.gridQueryString);
    console.info(this.props.searchParams);
    var gridDataResponse = await this.httpClient.fetchReceiptsData(this.props.searchParams.startDate, this.props.searchParams.location);
    var newGridData = gridDataResponse.data;
    console.log("newGridData: ");
    console.info(newGridData);
    this.setState({
      gridData: newGridData,
      isLoading: false
    });
  }

  onEditGridReady = params => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  };

  onGridReady = params => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    var savedColState = JSON.parse(this.auth.getUserProp(GRIDCOLSTATE));
    if (savedColState) {
      this.gridColumnApi.setColumnState(savedColState);
    }
  };


  lineStatusStyle(params)
  {
    if (!params.data.status) return {'background-color': 'white'};

    if (params.data.status.flowStatus === MsaReceiptStatusType.POSTEDTOMRA){  //   'POSTED-TO-MRA'){
      return {'background-color': '#7FFF3A'};
    } else if (params.data.status.flowStatus === MsaReceiptStatusType.TOQA){  // 'TO-QA'){
      return {'background-color': '#FFB641'};
    } else if (params.data.status.flowStatus === MsaReceiptStatusType.AWAITINGQA){ // 'AWAITING-QA'){
        return {'background-color': '#FFE750'};
    } else if (params.data.status.flowStatus === MsaReceiptStatusType.RECEIVEDQA){ // 'RECEIVED-QA'){
        return {'background-color': '#FFB641'};
    } else if (params.data.status.flowStatus === MsaReceiptStatusType.AWAITDISPOSITION){ //'AWAIT-DISPOSITION'){
        return {'background-color': '#FFE750'};
    } else if (params.data.status.flowStatus === MsaReceiptStatusType.VOIDED){ //'VOID'){
      return {'background-color': '#B3B3B3'}
    } else if (params.data.status.flowStatus === MsaReceiptStatusType.TOAUTOPILOT){ // 'TO-AUTOPILOT'){
      return {'background-color': '#7FFF3A'}
    } else if (params.data.status.flowStatus === MsaReceiptStatusType.TOPRINTERGNOME){ 
      return {'background-color': '#7FFF3A'}
    } else if (params.data.status.flowStatus === MsaReceiptStatusType.POSTEDTOFAMOUS){ //"POSTED-TO-FAMOUS"){
      return {'background-color': "#7FFF3A"}
    } else if (params.data.status.flowStatus === MsaReceiptStatusType.FAMOUSTAGSPRINTED){ //"FAMOUS-TAGS-PRINTED"){
      return {'background-color': "#7FFF3A"}
    } else if (params.data.status.flowStatus === MsaReceiptStatusType.AWAITINGFAMOUSRETRY){ // "AWAITING-FAMOUS-RETRY"){
      return {'background-color': "#FF5E00"}
    } else if (params.data.status.flowStatus === MsaReceiptStatusType.TAGPRINTERROR){ //"AWAITING-TAGPRINT-RETRY"){
      return {'background-color': "#FF5E00"}
    } else if (params.data.status.flowStatus === MsaReceiptStatusType.COMPLETE){ 
      return {'background-color': "#7FFF3A"}
    }
    else {
      return {'background-color': '#B3B3B3'}
    }
  }


  showAlertDialog(title, message, type){  //error warning info
    this.setState({alertTitle: title, alertMessage: message, alertType: type, showAlert: true});
  }

  onCloseAlert(){
    this.setState({showAlert: false});
  }
  

  onSelectionChanged() {
    var selectedNodes = this.gridApi.getSelectedNodes();
    var rowData =  selectedNodes[0].data; 
    this.setState({selectedRow: rowData});
    this.props.onDetailedGridRowChange(rowData);
  }

    // Controls
    onBtnExportDataAsCsv() {
      const saveParams = {
        allColumns: true,
        onlySelected: false,
        onlySelectedAllPages: false,
        skipHeader: false
      };
      this.gridApi.exportDataAsCsv(saveParams);
    }

    async onBtnDownloadDetailedDataAsCsv() {
      var searchParams = this.props.searchParams;
      await this.httpClient.fetchDetailedObservationDataAsCsv(searchParams);
    }

  
    onBtnSaveLayout() {
      var newGridColState = this.gridColumnApi.getColumnState();
    
      this.auth.setUserProp("msacc::" + GRIDCOLSTATE, JSON.stringify(newGridColState));
    }
  
    onBtnResetLayout() {
      this.gridColumnApi.resetColumnState();
      this.gridColumnApi.resetColumnGroupState();
      this.gridApi.setSortModel(null);
      this.gridApi.setFilterModel(null);
    }
  
    onBtnRestoreLayout() {
      var savedColState = JSON.parse(this.auth.getUserProp("msacc::" + GRIDCOLSTATE));
      if (savedColState) {
        this.gridColumnApi.setColumnState(savedColState);
      }
    }


  render() {

    const loadingIcon = (this.state.isLoading) ? 
      <FontAwesomeIcon icon="sync-alt" color="green" spin/> :
      ""

    const divStyle = {
      width: "100%",
      height: "calc(45vh)",
      
      margin: "5px",
      //border: '5px solid black'
    };

   

    
    const gridData = (this.state.gridData) ? this.state.gridData : [{}];

    return (
      <Card style={{maxWidth: "2000px", padding: "5px"}}>
        <Card.Header>
          <span style={{float: "left"}}>Receipts (last {this.props.receiptGridDaysAgo} days)</span>
          <span style={{float: "right"}}>{loadingIcon}</span>
        </Card.Header>
        <ReactTooltip/>
        <ModalAlertDialog
          show={this.state.showAlert}
          title={this.state.alertTitle}
          iconType={this.state.alertType} // error|warning|info
          message={this.state.alertMessage}
          onClose={this.onCloseAlert}

        />

        <Card.Body>
          <div style={{ width: "100%", height: "100%"}}>
            <Container fluid>
              <Row>
                <Col sm={7}>
                  <InputGroup size="sm">
                    <InputGroup.Prepend>
                      <InputGroup.Text id="basic-addon1">
                        Receipts
                      </InputGroup.Text>
                    </InputGroup.Prepend>
                    <p data-tip="Export grid data to csv">
                      <Button variant="outline-info" size="sm" onClick={this.onBtnExportDataAsCsv}>
                        <FontAwesomeIcon icon="file-export"/>
                      </Button>
                    </p>
                    <p data-tip="download ALL detailed observation data based on current search criteria">
                      <Button variant="outline-info" size="sm" onClick={this.onBtnDownloadDetailedDataAsCsv}>
                        <FontAwesomeIcon icon="file-download"/>
                      </Button>
                    </p>
                    <p data-tip="refresh receipts grid">
                      <Button variant="outline-info" size="sm" onClick={(e) => {this.refreshGridData()}}>
                        <FontAwesomeIcon icon={faSyncAlt}/>&nbsp;Refresh
                      </Button>
                    </p>
                  </InputGroup>
                </Col>
                <Col sm={5}>
                  <InputGroup size="sm">
                    <InputGroup.Prepend>
                      <InputGroup.Text id="basic-addon1">
                        Layout
                      </InputGroup.Text>
                    </InputGroup.Prepend>
                    <p data-tip="save current grid layout">
                      <Button variant="outline-info" size="sm" onClick={this.onBtnSaveLayout}>
                        <FontAwesomeIcon icon="save"/>
                      </Button>
                    </p>
                    <p data-tip="restore your saved grid layout">
                      <Button variant="outline-info" size="sm" onClick={this.onBtnResetLayout}>
                        <FontAwesomeIcon icon="trash-restore"/>
                      </Button>
                    </p>
                    <p data-tip="restore default grid layout">
                      <Button variant="outline-info" size="sm" onClick={this.onBtnRestoreLayout}>
                        <FontAwesomeIcon icon="bookmark"/>
                      </Button>
                    </p>
                  </InputGroup>
                </Col>
              </Row>
            </Container>

            <div className="ag-theme-balham" style={divStyle}>
              <AgGridReact
                rowSelection="single"
                enableRangeSelection={true}
                pagination={true}
                columnDefs={this.columnDefs}
                rowData={gridData}
                animateRows={true}
                onGridReady={this.onGridReady}
                onSelectionChanged={this.onSelectionChanged.bind(this)}
              />
            </div>
          </div>
        </Card.Body>
      </Card>
    );
  }
}
